import React from "react";
import UserRoleTable from "./components/UserRoleTable";

import { connect } from "react-redux";

const UserRoles = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">

	      	<UserRoleTable/>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(UserRoles);